import React, { useEffect, useState } from 'react';
import './checkbox.scss'
import { TreeNode } from './interface';

const TreeNodeComponent: React.FC<{ node: TreeNode, selectedCodes: string[], setSelectedCodes: Function }> = ({ node, selectedCodes, setSelectedCodes }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const selectedCode = selectedCodes ? selectedCodes : []
    useEffect(() => {
        if (selectedCode && selectedCode.includes(node.perm_code)) {
            setIsChecked(true);
            setIsOpen(true);
        }
    }, [selectedCode, node.perm_code]);

    const handleCheckboxChange = (code: string) => {
        const updatedSelectedCodes = isChecked
            ? selectedCode.filter((item: string) => item !== code)
            : [...selectedCode, code];

        setIsChecked(!isChecked);
        setIsOpen(!isOpen);
        setSelectedCodes(updatedSelectedCodes);
    };

    return (
        <li className='list-unstyled permission-checkbox '>
            <label>
                <input type="checkbox" className=' me-2 my-2' checked={isChecked} onChange={() => handleCheckboxChange(node.perm_code)} />
                {node.module_name}
            </label>
            {isOpen && node.child.length > 0 && (
                <ul>
                    {node.child.map((child: any, index: number) => (
                        <TreeNodeComponent key={index} node={child} selectedCodes={selectedCodes}
                            setSelectedCodes={setSelectedCodes} />
                    ))}
                </ul>
            )}
        </li>
    );
};

const UserPermissionUI = ({ structuredPermission, handleCheckboxChange, defaultPermission }: any) => {
    const [selectedCodes, setSelectedCodes] = useState<string[]>([]);
    const treeData: any = structuredPermission;
    useEffect(() => {
        if (defaultPermission) {
            const extractedCodes = defaultPermission && defaultPermission.flatMap(extractPermCodes);
            setSelectedCodes(extractedCodes);
        }
        // handleCheckboxChange(selectedCodes);
    }, [defaultPermission]);
    useEffect(() => {
        handleCheckboxChange(selectedCodes);
    }, [selectedCodes]);

    const extractPermCodes = (permission: any) => 
        // extractPermCodes(permission)
        [
            permission.perm_code,
            ...(permission.child ? permission && permission.child.flatMap(extractPermCodes) : [])
        ];
    // }

return (
    <div id="tree">
        <ul>
            {treeData.map((node: any, index: number) => (
                <TreeNodeComponent key={index} node={node} selectedCodes={selectedCodes}
                    setSelectedCodes={setSelectedCodes}
                />
            ))}
        </ul>
    </div>
);
};

export default UserPermissionUI;
